export default __webpack_public_path__ + "static/media/404.67daa822.svg";